/* SHIROÉ — scroll reveal + mobile sticky add-to-cart.
   The FAQ uses native <details>, so it needs no JS to open. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = null;

  function revealAll() {
    document.querySelectorAll('.sh-fade').forEach(function (el) { el.classList.add('is-in'); });
  }

  // .sh-fade starts at opacity 0, so any failure here must fall back to visible
  // rather than leaving the page blank.
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return revealAll();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // A fast flick-scroll can report an element as already past the
        // viewport rather than intersecting. Without the top < 0 check it would
        // stay at opacity 0 forever and the section would read as blank.
        var passed = entry.boundingClientRect.top < 0;
        if (!entry.isIntersecting && !passed) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });

    document.querySelectorAll('.sh-fade').forEach(function (el) { io.observe(el); });

    // Last resort: anything still hidden after 3s gets shown regardless. Better
    // a missed animation than content nobody can read.
    setTimeout(revealAll, 3000);
  }

  // Reveal the sticky bar only once the real buy button has scrolled away, so
  // the two are never on screen competing with each other.
  function initSticky() {
    var bar = document.querySelector('[data-shiroe-sticky]');
    var anchor = document.querySelector('[data-shiroe-buy-anchor]');
    if (!bar || !anchor) return;

    // A passive scroll listener rather than an IntersectionObserver: this bar is
    // the main conversion path on mobile, so it reads the anchor's position
    // directly. Deliberately not rAF-wrapped — browsers already coalesce scroll
    // events to roughly one per frame, so the wrapper bought nothing and made
    // the bar depend on rAF actually running.
    function update() {
      // Show once the buy button and its trust list have scrolled off the top.
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Hand off to Dawn's own product form rather than duplicating cart logic.
    var btn = bar.querySelector('[data-shiroe-sticky-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var form = document.querySelector('product-form form');
      var submit = form && form.querySelector('[type="submit"]');
      if (submit) return submit.click();
      anchor.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    });
  }


  // Video hero: play a clip only while it is on screen, and never on a
  // reduced-motion setting. preload="none" means nothing downloads until then.
  function initVideoHero() {
    var vids = document.querySelectorAll("[data-shiroe-video]");
    if (!vids.length) return;
    if (reduced || !("IntersectionObserver" in window)) return; // posters stand in

    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.preload === "none") v.preload = "auto";
          var p = v.play();
          if (p && p.catch) p.catch(function () { v.setAttribute("data-stalled", ""); });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    vids.forEach(function (v) { videoObserver.observe(v); });
  }


  // Product rail arrows. Scrolling itself is native scroll-snap, so a JS
  // failure leaves a still-swipeable rail rather than a broken one. Arrows
  // page by one card width and disable at each end.
  function initRails() {
    document.querySelectorAll("[data-shiroe-rail]").forEach(function (wrap) {
      var rail = wrap.querySelector("[data-rail]");
      var prev = wrap.querySelector("[data-rail-prev]");
      var next = wrap.querySelector("[data-rail-next]");
      if (!rail || !prev || !next) return;

      function step() {
        var card = rail.firstElementChild;
        if (!card) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }
      prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: reduced ? "auto" : "smooth" }); });
      next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: reduced ? "auto" : "smooth" }); });
      rail.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync, { passive: true });
      sync();
    });
  }

  function init() { initReveal(); initSticky(); initVideoHero(); initRails(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Header submenus open on hover.

   Dawn drives these <details> panels by click, which is right for touch and for
   keyboards but leaves a pointer user clicking to see a menu. Hover is layered
   on top rather than replacing it: the click and keyboard paths Dawn already
   ships keep working, and this only adds intent-based opening for devices that
   actually have a hovering pointer.

   The close is delayed by a beat because the pointer has to cross a small gap
   between the link and the panel below it; closing instantly there makes the
   menu feel like it is running away from the cursor. */
(function () {
  var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  if (!canHover.matches) return;

  var items = document.querySelectorAll('.header__inline-menu > ul > li');

  items.forEach(function (li) {
    var details = li.querySelector('header-menu > details');
    if (!details) return;

    var closeTimer = null;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      /* Only one panel at a time, or two overlap when the pointer skims across. */
      items.forEach(function (other) {
        var d = other.querySelector('header-menu > details');
        if (d && d !== details) d.removeAttribute('open');
      });
      details.setAttribute('open', '');
    }

    function scheduleClose() {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 180);
    }

    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', scheduleClose);

    /* Escape closes, matching the behaviour of the click-opened panel. */
    li.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') details.removeAttribute('open');
    });
  });
})();


/* Collection sort submits on change. Without this the select is a control that
   looks interactive and does nothing until a submit button is found. */
(function () {
  document.querySelectorAll('[data-shiroe-sort] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      sel.form.submit();
    });
  });
})();


/* Publishes the header's height as --sh-header-h.

   The homepage lifts its first section by exactly this amount so the hero runs
   to the top of the page behind a transparent header. A hard-coded value would
   be wrong the moment the wordmark, the padding or the viewport changed, and
   the symptom would be a sliver of background above the video. */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  var root = document.documentElement;
  var frame = null;

  function measure() {
    var bar = document.querySelector('.section-header .header-wrapper');
    if (!bar) return;
    root.style.setProperty('--sh-header-h', bar.offsetHeight + 'px');
  }

  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measure);
  }

  measure();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  /* Webfonts land after first paint and change the wordmark's height. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
})();

/* Hero slider.

   The track is a scroll-snap container, so swiping and sideways scrolling work
   with no script at all. This only layers on the timer, arrows and dots.

   The timer stops permanently the first time the visitor drives the slider
   themselves: a carousel that keeps yanking the frame away after someone has
   chosen a slide is the single most complained-about pattern in this component.
   It also pauses on hover, on keyboard focus, and whenever the tab is hidden. */
(function () {
  document.querySelectorAll('[data-shiroe-hero]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.sh-hs__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (slides.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wait = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var index = 0;
    var timer = null;
    var surrendered = false;

    function mark(i) {
      index = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    var animating = false;
    var animGuard = null;

    function goTo(i, userDriven) {
      var target = ((i % slides.length) + slides.length) % slides.length;
      /* Scroll to the slide's own offset rather than index*clientWidth:
         the two drift apart the moment a scrollbar or sub-pixel width
         enters the picture, and the drift is what strands the track. */
      animating = true;
      /* Assigning scrollLeft and letting CSS scroll-behavior do the easing,
         rather than scrollTo({behavior:'smooth'}).
         Verified in the live page: on this mandatory scroll-snap container
         scrollTo({behavior:'smooth'}) is swallowed and the track never
         moves, while both scrollTo({behavior:'auto'}) and a direct
         scrollLeft assignment land exactly on the slide. */
      track.style.scrollBehavior = reduced ? 'auto' : 'smooth';
      track.scrollLeft = slides[target].offsetLeft;
      mark(target);
      /* Hold the flag for the length of the animation rather than until
         the first scroll event. A smooth scroll fires its first event
         only a few pixels in, and anything that reads the position then
         sees a half-finished move. */
      clearTimeout(animGuard);
      animGuard = setTimeout(function () { animating = false; }, 900);
      if (userDriven) stopForGood();
    }

    /* Never start a new move while one is still running: overlapping
       smooth scrolls cancel each other and leave the track between
       slides, which is exactly the two-slides-at-once symptom. */
    function tick() { if (!animating) goTo(index + 1, false); }
    function start() {
      if (surrendered || reduced || timer) return;
      timer = setInterval(tick, wait);
    }
    function pause() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function stopForGood() { surrendered = true; pause(); }

    /* Whichever slide the scroll settles on becomes current, so a manual swipe
       and the dots never disagree about where we are. */
    var settleTimer = null;
    track.addEventListener('scroll', function () {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        /* A move we started owns the position until it finishes; reading
           it mid-flight and "correcting" is what cancelled the animation
           and left the dots disagreeing with the track. Only a scroll the
           visitor drove gets to redefine which slide is current. */
        if (animating) return;
        var nearest = 0, best = Infinity;
        slides.forEach(function (s, n) {
          var d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = n; }
        });
        mark(nearest);
        /* Snapping is done here rather than by the browser, so a swipe
           that stops between two slides still comes to rest on one. */
        if (best > 1) {
          track.style.scrollBehavior = reduced ? 'auto' : 'smooth';
          track.scrollLeft = slides[nearest].offsetLeft;
        }
      }, 120);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(index + 1, true); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i, true); });
    });
    track.addEventListener('pointerdown', stopForGood);

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else start();
    });

    window.addEventListener('resize', function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = slides[index].offsetLeft;
    });

    start();
  });
})();


/* PDP gallery: the featured cutout is hidden from the gallery, but Dawn can
   initialise with that hidden slide as the active one, leaving the stage
   blank. If the active slide is the hidden first item, hand the state to the
   first visible thumbnail through Dawn's own click path. */
(function () {
  function fix() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var active = list.querySelector('.product__media-item.is-active');
    var first = list.querySelector('.product__media-item:first-child');
    if (!active || active === first) {
      var thumb = document.querySelector('.thumbnail-list .thumbnail-list__item:not(:first-child) .thumbnail');
      if (thumb) thumb.click();
    }
  }
  window.addEventListener('load', function () { setTimeout(fix, 350); });
})();


/* Card quantity stepper.

   One number drives two destinations: the add-to-cart form posts it, and the
   express link rebuilds its cart permalink from it. Keeping both in sync from
   a single source is what stops the classic bug where the stepper shows 3 and
   the checkout arrives holding 1.

   The input is a real number field, so typing and arrow keys work; the buttons
   are a convenience layered on top rather than the only way in. */
(function () {
  document.querySelectorAll('[data-shiroe-buy]').forEach(function (box) {
    var input = box.querySelector('[data-qty]');
    var mirror = box.querySelector('[data-qty-mirror]');
    var buynow = box.querySelector('[data-buynow]');
    var minus = box.querySelector('[data-step="-1"]');
    var plus = box.querySelector('[data-step="1"]');
    if (!input) return;

    var variant = box.dataset.variant;
    var cart = box.dataset.cart || '/cart';
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 10;

    function sync() {
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = min;
      n = Math.max(min, Math.min(max, n));
      input.value = n;
      if (mirror) mirror.value = n;
      if (buynow) buynow.href = cart + '/' + variant + ':' + n;
      if (minus) minus.disabled = n <= min;
      if (plus) plus.disabled = n >= max;
    }

    function step(by) {
      input.value = (parseInt(input.value, 10) || min) + by;
      sync();
    }

    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('input', sync);
    input.addEventListener('blur', sync);
    sync();
  });
})();

/* Product gallery auto-advance, every 5s.

   Drives the gallery through its own thumbnail click path rather than
   reaching into Dawn's internals, so active state, thumbnail highlight and
   lazy loading all stay consistent with a real click.

   Hover-pause is armed only after the visitor actually moves the mouse. A
   plain mouseenter listener pauses on load whenever the cursor already
   happens to rest over the gallery — which is what stopped the first
   version of this from ever ticking.

   It stops for good the moment the visitor picks a panel themselves: these
   images carry text someone may be mid-sentence in, and moving it under
   them is the worst thing this component can do. */
(function () {
  var list = document.querySelector('.thumbnail-list');
  if (!list) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var thumbs = [].slice.call(list.querySelectorAll('.thumbnail-list__item'))
    .filter(function (li) { return getComputedStyle(li).display !== 'none'; })
    .map(function (li) { return li.querySelector('.thumbnail'); })
    .filter(Boolean);
  if (thumbs.length < 2) return;

  var timer = null, surrendered = false, hoverArmed = false;

  function currentIndex() {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }
  function advance() {
    var t = thumbs[(currentIndex() + 1) % thumbs.length];
    if (t) t.click();
  }
  function start() { if (!surrendered && !timer) timer = setInterval(advance, 5000); }
  function pause() { if (timer) { clearInterval(timer); timer = null; } }
  function stopForGood() { surrendered = true; pause(); }

  var gallery = document.querySelector('.product__media-wrapper') || list;
  /* Only a real user gesture surrenders the carousel. A bare click listener
     was firing during Dawn's own gallery initialisation, so it stopped before
     it ever ticked — event.isTrusted is false for scripted clicks and true
     only for genuine input. */
  gallery.addEventListener('click', function (e) { if (e.isTrusted) stopForGood(); });
  gallery.addEventListener('keydown', function (e) { if (e.isTrusted) stopForGood(); });
  window.addEventListener('mousemove', function () { hoverArmed = true; }, { once: true });
  gallery.addEventListener('mouseenter', function () { if (hoverArmed) pause(); });
  gallery.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pause(); else start();
  });

  window.__shiroeGallery = {
    running: function () { return !!timer; },
    surrendered: function () { return surrendered; },
    index: currentIndex,
    /* Called by the drag handler. A synthetic click cannot be used for this:
       the surrender guard checks event.isTrusted, so a scripted click is
       correctly ignored — which left the carousel advancing mid-drag. */
    stop: stopForGood
  };
  start();
})();


/* Product gallery: drag on desktop, swipe on a phone.

   Movement is translated into a thumbnail click, the same path the arrows
   and the auto-advance use, so active state and lazy loading stay consistent
   however the panel was changed.

   Two things this has to get right:
   - A drag must not open the zoom modal. The click that follows a drag is
     swallowed in the capture phase, so a real tap still zooms.
   - A vertical scroll must not be read as a horizontal swipe. The gesture is
     only claimed once horizontal movement clearly exceeds vertical, which is
     what stops the page feeling sticky under a thumb. */
(function () {
  var wrap = document.querySelector('.product__media-wrapper');
  var list = document.querySelector('.thumbnail-list');
  if (!wrap || !list) return;

  var thumbs = [].slice.call(list.querySelectorAll('.thumbnail-list__item'))
    .filter(function (li) { return getComputedStyle(li).display !== 'none'; })
    .map(function (li) { return li.querySelector('.thumbnail'); })
    .filter(Boolean);
  if (thumbs.length < 2) return;

  var THRESHOLD = 45;
  var startX = 0, startY = 0, down = false, claimed = false, justDragged = false;

  /* Below 750px Dawn's gallery is a real horizontal scroll-snap slider, and
     the browser already does momentum, snapping and rubber-banding better
     than this handler can. Worse, claiming the gesture here means calling
     preventDefault on pointermove, which kills that native scroll outright —
     the swipe simply stops working. So on a phone this stands down entirely
     and lets the slider do its job. Checked per gesture rather than once at
     load, so rotating the device does the right thing. */
  function nativeSliderOwnsIt() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function currentIndex() {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }
  function go(dir) {
    var n = (currentIndex() + dir + thumbs.length) % thumbs.length;
    if (thumbs[n]) thumbs[n].click();
  }

  wrap.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    if (nativeSliderOwnsIt()) return;
    down = true; claimed = false;
    startX = e.clientX; startY = e.clientY;
  });

  wrap.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (!claimed && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
      claimed = true;
      wrap.classList.add('is-grabbing');
      /* The visitor is driving now — hand the carousel its own stop. */
      if (window.__shiroeGallery && window.__shiroeGallery.stop) {
        window.__shiroeGallery.stop();
      }
    }
    if (claimed) e.preventDefault();
  }, { passive: false });

  function release(e) {
    if (!down) return;
    var dx = (e.clientX || 0) - startX;
    down = false;
    wrap.classList.remove('is-grabbing');
    if (claimed && Math.abs(dx) > THRESHOLD) {
      go(dx < 0 ? 1 : -1);
      justDragged = true;
      setTimeout(function () { justDragged = false; }, 0);
    }
    claimed = false;
  }
  wrap.addEventListener('pointerup', release);
  wrap.addEventListener('pointercancel', release);
  wrap.addEventListener('pointerleave', release);

  /* A drag ends in a click the browser still fires — swallow it so the zoom
     modal only opens on a genuine tap. */
  wrap.addEventListener('click', function (e) {
    if (justDragged) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });

  window.__shiroeGalleryDrag = { threshold: THRESHOLD, panels: thumbs.length };
})();

/* Dawn renders a play button over each deferred video poster with no text
   and no aria-label, so a screen reader announces only "button". It also
   renders the media twice — once in the gallery, once in the lightbox —
   which duplicates the id. Both copies are labelled here, and the second
   copy's id is suffixed so the document has no duplicate ids.

   Done in script rather than Liquid because the markup comes from Dawn's
   own snippet, which is safer left unforked. */
(function () {
  var seen = Object.create(null);
  document.querySelectorAll('.deferred-media__poster').forEach(function (btn) {
    if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
      var media = btn.closest('.product__media-item, .deferred-media');
      var img = media && media.querySelector('img[alt]');
      var what = img && img.getAttribute('alt') ? img.getAttribute('alt') : 'product video';
      btn.setAttribute('aria-label', 'Play ' + what);
    }
    var id = btn.getAttribute('id');
    if (!id) return;
    if (seen[id]) {
      btn.setAttribute('id', id + '-' + (++seen[id]));
    } else {
      seen[id] = 1;
    }
  });
})();
